import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.AuditLogServiceServiceProxy,
        ApiServiceProxies.JobsServiceProxy,
        ApiServiceProxies.TimesheetServiceProxy,
        ApiServiceProxies.MessagesServiceProxy,
        ApiServiceProxies.TimeLogServiceProxy,
        ApiServiceProxies.ExpensesReceiptServiceProxy,
        ApiServiceProxies.TimeOffRequestsServiceProxy,
        ApiServiceProxies.RateSettingServiceProxy,
        ApiServiceProxies.AppSettingsServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
